import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getDateOperatorLogList, getMediaWallProgram} from '@apis'
import moment from 'moment'
import {Chart} from '@antv/g2'
import energyWarningBg from '../../../assets/img/energyWarningBg.png'

const dateOperator = [
  9,8,7,6,5,4,3,2,1,0
]
let timer

const PlayTimeData = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId, strongProjectId: projectId} = userInfo

    async function queryProgramList() {
      const params = {
        projectId,
        pageNo: 1,
        pageSize: 999,
      }
      const res = await getMediaWallProgram(params)
      if (res && res.data) {
        const data = []
        dateOperator.map((item, index) => {
          let num = 0
          res.data.map(Program => {
            if(Program.taskSwitch) {
              if(Program.playFrequency == 1) {
                Program.weekList.map(value => {
                  if(value == new Date(new Date().valueOf()-(item+1)*24*60*60*1000).getDay()) {
                    Program.timeThresholdList.map(() => {
                      num++
                    })
                  }
                })
              } else {
                if(moment(Number(Program.playDayStart)).format("YYYY:MM:DD") <= moment(new Date(new Date().valueOf()-(item+1)*24*60*60*1000)).format("YYYY:MM:DD") && 
                moment(Number(Program.playDayEnd)).format("YYYY:MM:DD") >= moment(new Date(new Date().valueOf()-(item+1)*24*60*60*1000)).format("YYYY:MM:DD")) {
                  Program.timeThresholdList.map(() => {
                    num++
                  })
                }
              }
            }
          })
          data[index] = num
        })
        queryDateOperator(data)
      }
    }

    function queryDateOperator(autoPlay) {
      const data = []
      dateOperator.map((item, index) => {
        const params = {
          brokerId,
          startTime: moment(new Date()-(item+1)*24*60*60*1000).format('YYYY-MM-DD'),
          endTime: moment(new Date()-item*24*60*60*1000).format('YYYY-MM-DD')
        }
        getDateOperatorLogList(params).then(res => {
          if(res) {
            let num = 0
            res.map(values => {
              if(values.operatorUrl == '/program/playProgram' && JSON.parse(values.json).playStatus == 1) {
                num++
              }
            })
            data[index] = num+1 + autoPlay[index]
          }
        })
      })
      clearInterval(timer)
      timer = setInterval(() => {
        if(data[9]) {
          clearInterval(timer)
          creatChat(data)
        }
      }, 50)
    }

    function creatChat(num) {
      const data = [
        {day: moment(new Date()-10*24*60*60*1000).format('D') + '日', 次数: num[0]-1},
        {day: moment(new Date()-9*24*60*60*1000).format('D') + '日', 次数: num[1]-1},
        {day: moment(new Date()-8*24*60*60*1000).format('D') + '日', 次数: num[2]-1},
        {day: moment(new Date()-7*24*60*60*1000).format('D') + '日', 次数: num[3]-1},
        {day: moment(new Date()-6*24*60*60*1000).format('D') + '日', 次数: num[4]-1},
        {day: moment(new Date()-5*24*60*60*1000).format('D') + '日', 次数: num[5]-1},
        {day: moment(new Date()-4*24*60*60*1000).format('D') + '日', 次数: num[6]-1},
        {day: moment(new Date()-3*24*60*60*1000).format('D') + '日', 次数: num[7]-1},
        {day: moment(new Date()-2*24*60*60*1000).format('D') + '日', 次数: num[8]-1},
        {day: moment(new Date()-24*60*60*1000).format('D') + '日', 次数: num[9]-1},
      ];
      const chart = new Chart({
        container: 'container',
        autoFit: true,
        height: 340,
      });

      chart.data(data);
      chart.scale('次数', {
        nice: true,
      });

      chart.tooltip({
        showMarkers: false
      });
      chart.interaction('active-region');

      chart.interval()
        .position('day*次数')
        .color('rgb(16, 250, 233)');

      chart.render();
    }

    useEffect(() => {
      queryProgramList()
    }, [])

    return (
      <div className='ck-play-time'>
        <div className='title'>历史播放次数</div>
        <img className='ck-play-bg' src={energyWarningBg} />
        <div className='playTime-item'>
          <div className='playTime-index'>
            <div id='container' className='container'>
            </div>
          </div>
        </div>
      </div>
    )
  })
)

export default PlayTimeData
